import { render, staticRenderFns } from "./item_detail.vue?vue&type=template&id=5a883dfa&"
import script from "./item_detail.vue?vue&type=script&lang=js&"
export * from "./item_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports